/* Change label to "Sales Forecasting" Jan 21, 2023 */
/* Add side-nav-toggle-sticky Jun 18, 2023 */
/* Add and use fn_checkPageEnabled Apr 13, 2024 */
/* Add ReveneForecasting Aug 8, 2026 */
<template lang="pug">
	div(id="side-nav" :class="d_collapsed? 'collapsed' : null" @touchstart="m_touchST")
		div(id="side-nav-toggle" class="side-nav-toggle-sticky")
			b-dropdown(v-if="false" dropright variant="outline-secondary" v-show="!d_collapsed")
				div(class="dropdown-header py-2")
					span Show or Hide Menu Items
				div(class="dropdown-item" v-for ="i in c_sideNavOpt" :key="i.key" @click="m_sideNavOptSave(i)")
					span(:class="i.icon?null:'pl-2'")
						fa-icon(v-if="i.icon" :icon="i.icon" :color="i.color||null")
						|{{i.icon ?'':'↳'}}
						|{{i.prntLabel}}
						|{{i.label}}
					span
						fa-icon(:icon="i.hidden ? 'eye-slash' : 'eye'")
				template(v-slot:button-content)
					fa-icon(icon="cog")
					//- | Options
			b-button(size="sm" variant="none" title="Show/Hide Navigation Panel" 
				:class="d_collapsed? 'collapsed' : null" @click="m_sidnavCollapse")
				fa-icon(:icon="d_collapsed?'chevron-right':'chevron-left'")
				fa-icon(:icon="d_collapsed?'bars':'times'")
		div(id="side-nav-list" class="side-nav-list-sticky")
			div(v-for ="(i, ix) in d_navItems.filter(x=> !x.hidden)" :key="ix" :class="i.key=='divider'?'br':null")
				router-link(:to="{path: '/kbdp/#'+i.key}" :class="i.key == d_appEnt ? 'router-link-active':null")
					fa-icon(v-if="i.icon" :icon="i.icon" :color="i.color||null")
					| {{i.label}}
				div(v-for="si in i.subEnt" :key="si.key" v-if="!si.hidden")
					span ↳ 
					router-link( :to="{path: '/kbdp/#'+si.key}")
						fa-icon(v-if="si.icon" :icon="si.icon" :color="si.color||null") 
						| {{si.label}}

</template>

<script>

import {fn_checkPageEnabled,fn_saveUserOpts} from "@/utils/util.js";
import {appEntities, userSettings} from "@/utils/ref-data.js";

export default {
	name: "side-nav",
	components: {},
	created() {
		fn_setNavItems(this);
		fn_setAppEnt(this);
		//fn_setSideNavOpts(this);
	},
	mounted() {
		let mm = window.matchMedia("(max-width: 576px)");
		if (mm.matches) this.m_sidnavCollapse();
	},
	data() {
		return {
			d_navItems: null,
			d_appEnt: null,
			d_collapsed: false,
		};
	},
	props: {
	},
	computed: {
		c_sideNavOpt() {
			let opts = [];
			this.d_navItems.forEach(x => {
				if (!/^(oppr|proj|acct)$/.test(x.key)) opts.push(x);
				(x.subEnt || []).forEach(se => opts.push(se));
			});
			return opts;
		},
		// c_isTouch() {
		// 	return this.$root.$children[0].d_isTouch;
		// }
	},
	methods: {
		m_checkPage(page){return fn_checkPageEnabled(page);},
		m_sidnavCollapse() {
			//Called from KBDP as well
			this.d_collapsed = !this.d_collapsed;
			$(this.$el.parentElement.parentElement).toggleClass('side-nav-collapsed');
		},
		m_sideNavOptSave(i) {
			i.hidden = !i.hidden;

			if (i.hidden) {
				(i.subEnt || []).forEach(se => se.hidden = true);
			}
			else if (i.key == 'cal-activities') {
				this.d_navItems.filter(x => x.key == 'calendar')[0].hidden = null;
			}

			let val = {};
			this.c_sideNavOpt.filter(x => x.hidden !== undefined).forEach(x => {
				val[x.key] = x.hidden;
			});
			fn_saveUserOpts('sideNavItemsHidden', null, val);
		},
		m_touchST(e) {
			if (e.target.id != 'side-nav') return;

			let strtX = e.touches[0].clientX;
			let strtY = e.touches[0].clientY;

			let endX, endY;
			$(e.target).on('touchmove', e2 => {
				endX = e2.touches[0].clientX;
				endY = e2.touches[0].clientY;
			});

			$(e.target).one('touchend', e3 => {
				$(e.target).off('touchmove');

				let diffX = (endX - strtX);
				let diffY = (endY - strtY);
				if (Math.abs(diffX) > Math.abs(diffY) && diffX < -50) {
					// console.log('Swipe Left', diffX);
					this.m_sidnavCollapse();
				}
			});
		},
	},
	watch: {
		'$route.hash'(nv) {
			fn_setAppEnt(this);
		}
	}
};


function fn_setAppEnt(vc) {
	vc.d_appEnt = vc.$route.hash.substring(1, 5);
}
function fn_setNavItems(vc) {
	let ni = [
		{
			key: 'dashboard',
			label: 'Dashboard',
			icon: 'tachometer-alt',
			color: '#4fa4ff',
			hidden: !fn_checkPageEnabled('Dashboard')
		},
		{
			key: 'calendar',
			label: 'Calendar',
			icon: ['far', 'calendar-alt'],
			color: '#4fa4ff',
			hidden: !fn_checkPageEnabled('Calendar'),
			subEnt: [
				{
					key: 'cal-activities',
					name: 'calendarTask',
					label: 'Activities',
					prntLabel: 'Calendar',
					hidden: !fn_checkPageEnabled('Calendar Activities'),
				},
				{
					key: 'meetings',
					name: 'Meetings',
					label: 'Meetings',
					prntLabel: 'Calendar',
					hidden: !fn_checkPageEnabled('Meetings'),
				}				
			],
		},
		{
			key: 'forecasting',
			label: 'Forecasting',
			icon: 'bullseye',
			color: '#dc3545',
			hidden1: !fn_checkPageEnabled('Sales Forecasting'),
			subEnt: [
				{
					key: 'salesGoals',
					name: 'salesGolas',
					label: 'Sales',
					hidden: !fn_checkPageEnabled('Sales Forecasting'),
				},
				{
					key: 'revenueForecasting',
					name: 'RevenueForecasting',
					label: 'Revenue',
					hidden: !fn_checkPageEnabled('Revenue Forecasting'),
				}				
			],
		},
		{
			key: 'divider',
			label: null,
			hidden: false
		},
	];

	let ae = appEntities.filter(x => !/^(task|cal)$/.test(x.key));
	ae.forEach(e=>{

				if(e.hiddenFn) e.hidden=e.hiddenFn();
				if(e.subEnt){
							if(e.subEnt[0].hiddenFn) e.subEnt[0].hidden=e.subEnt[0].hiddenFn();
							}
				});
	vc.d_navItems = ni.concat(ae);
}
function fn_setSideNavOpts(vc) {
	let usrOpt = userSettings.userOptions.sideNavItemsHidden || {};
	Object.keys(usrOpt).forEach(uoKey => {
		let ni = vc.c_sideNavOpt.filter(x => x.key == uoKey)[0];
		//if (ni) ni.hidden = usrOpt[uoKey];
	});
}

</script>


<style scoped lang="less">
#side-nav {
	height: 100%;
	#side-nav-toggle {
		display: flex;
		justify-content: space-between;
		.dropdown {
			margin: 0.4em 1em;
			button.dropdown-toggle {
				padding: 0em 0.3em;
				font-size: 0.9em;
				opacity: 0.8;
			}
			.dropdown-menu {
				padding-bottom: 0.5em;
				width: 200px;
				background-color: #fff;
				z-index: 101; //Above .kt-chat
				.dropdown-item {
					padding: 0.1em 0.5em;
					cursor: pointer;
					display: flex;
					justify-content: space-between;
					> span:first-child {
						// display: inline-block;
						// width: 85%;
						font-size: 0.9em;
						// padding-left: 0.5em;
						svg {
							width: 15px;
							margin-right: 0.3em;
							opacity: 0.8;
						}
					}
					> span:last-child {
						svg {
							&[data-icon="eye"] {
								color: #4fa4ff;
							}
							&[data-icon="eye-slash"] {
								opacity: 0.4;
							}
						}
					}

					&:nth-child(5) {
						margin-bottom: 0.4em;
						border-bottom: solid 0.1em #adb5bd;
					}
				}
			}
		}
		> button {
			padding: 0.1em 0.6em;
		}
	}

	#side-nav-list {
		// height: calc(100% - 90px);
		// padding-top: 0.5em;
		padding-left: 0.5em;
		margin-bottom: 1em;
		text-align: left;
		min-width: 160px;
		> div {
			font-size: 0.9em;
			padding-bottom: 0.2em;

			a:first-child {
				display: block;
				padding: 0.4em 0;
				padding-left: 0.3em;
				border-left: solid 0.2em transparent;
				&:hover {
					border-left-color: #6c757d;
				}
				&.router-link-active {
					background-color: #f3f2f2;
				}
				&.router-link-exact-active {
					text-decoration: underline;
					border-left-color: #6c757d;
				}
				svg {
					width: 15px;
					margin-right: 0.3em;
					opacity: 0.8;
				}
			}

			> div {
				margin-left: 1.25em;
				a {
					display: unset;
					padding: 0;
					font-size: 0.9em;
					&.router-link-active {
						font-weight: bolder;
						text-decoration: underline;
					}
				}
			}

			&.br {
				margin-top: 0.4em;
				padding-top: 0.5em;
				border-top: solid 0.1em #adb5bd;
			}
		}
	}

	&.collapsed {
		> div:nth-child(n + 2) {
			display: none;
		}
	}

	@media (min-width: 576px) {
		#side-nav-toggle {
			> button {
				opacity: 0.5;
				margin: 0.3em;
				svg.fa-times,
				svg.fa-bars {
					display: none;
				}
				&:hover {
					background-color: #e9ecef;
					opacity: unset;
				}
				&.collapsed:hover {
					background-color: #ced4da;
				}
			}
		}
		&.collapsed {
			background-color: #e9ecef;
			width: 40px;

			#side-nav-toggle {
				> button {
					margin: 0.3em auto;
				}
			}
		}
	}
	@media (max-width: 576px) {
		// border: solid 0.1em red;
		&.collapsed {
			width: inherit;
			#side-nav-toggle {
				margin-top: 0.4em;
				padding-left: 0.5em;
				border: solid 0.05em #ced4da;
				border-left: unset;
				border-radius: 0.25em;
				background-color: #ffffff;
				button {
					// border: solid 0.05em #ced4da;
					color: #4fa4ff;
					font-size: 1.3em;
				}
			}
		}
		&:not(.collapsed) {
			border-right: solid 0.1em #6c757d;
			#side-nav-toggle {
				padding-top: 0.4em;
				padding-right: 0.5em;
				button {
					font-size: 1em;
					padding: 0em 0.4em;
				}
			}
		}
		#side-nav-toggle {
			button {
				svg.fa-chevron-left,
				svg.fa-chevron-right {
					display: none;
				}
			}
		}
	}
}
.side-nav-toggle-sticky{
	position:sticky; 
	top:88px; 
	z-index:6; 
	background:white;
	}
.side-nav-list-sticky{
	position:sticky; 
	top:125px; 
	z-index:3; 
	background:white;
	}
</style>